export const getProductSchema = (product) => {
  const images = [
    product.media.thumb.full_path,
    ...product.media.gallery.map((image) => image.full_path),
  ];
  const reviews = product?.reviews?.map((comment) => {
    const { user_name, title, content, created_at, score } = comment;
    return {
      '@type': 'Review',
      author: {
        '@type': 'Person',
        name: `${user_name == ' ' ? 'کاربر سایت' : user_name}`,
      },
      datePublished: created_at,
      reviewBody: content,
      name: title,
      reviewRating: {
        '@type': 'Rating',
        bestRating: 5,
        ratingValue: score,
        worstRating: 1,
      },
    };
  });
  const productSchema = {
    '@context': 'http://schema.org/',
    '@type': 'Product',
    name: product.title,
    description: product.seo.description,
    mpn: product.sku,
    sku: product.sku,
    category: `${process.env.NEXT_PUBLIC_SITE_URL}/cat${product.categoryUrl}`,
    image: [...images],
    brand: {
      '@type': 'Brand',
      name: product.brand.title,
      url: `${process.env.NEXT_PUBLIC_SITE_URL}/brand${product.brand.url}`,
      '@id': `${process.env.NEXT_PUBLIC_SITE_URL}/brand${product.brand.url}/#brand`,
    },
    ...(product.total > 0 && {
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: product.score,
        reviewCount: product.total,
      },
    }),
    offers: {
      '@type': 'Offer',
      priceCurrency: 'IRR',
      price: (product.price.sale || 0) * 10,
      itemCondition: 'https://schema.org/NewCondition',
      availability: `${
        product.price.stock > 0
          ? ' https://schema.org/InStock'
          : 'https://schema.org/OutOfStock'
      }`,
    },
    review: reviews,
  };
  return productSchema;
};

export const getOtherPageSchema = (pageData) => {
  const pageSchema = {};
  return pageSchema;
};
export const getBreadcrumbSchema = (breadcrumb, objectTitle, type) => {
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          '@id': `${process.env.NEXT_PUBLIC_SITE_URL}`,
          name: 'فروشگاه اینترنتی برقچی',
        },
      },
      // Dynamic breadcrumb items
      ...(breadcrumb && breadcrumb.length > 0
        ? breadcrumb
            .slice(0)
            .reverse()
            .map((item, index) => ({
              '@type': 'ListItem',
              position: index + 2,
              item: {
                '@id': `${process.env.NEXT_PUBLIC_SITE_URL}/${
                  type == 'brand' ? '' : 'cat'
                }${item.link}`,
                name: item.title,
              },
            }))
        : []),
      // Last breadcrumb item with the object title
      type != 'index' && {
        '@type': 'ListItem',
        position: (breadcrumb ? breadcrumb.length : 0) + 2,
        item: {
          '@id': '',
          name: objectTitle,
        },
      },
    ],
  };
  return breadcrumbSchema;
};

export const getIndexSchema = (object) => {
  const indexSchema = [
    {
      '@context': 'https://schema.org',
      '@type': 'Corporation',
      id: 'https://www.barghchi.com/#corporation',
      name: 'برقچی',
      alternateName: ['برقچی', 'barghchi'],
      legalName: 'سپهرفیدار هوشمند',
      url: 'https://www.barghchi.com',
      logo: '',
      email: 'info@barghchi.com',
      sameAs: ['https://www.instagram.com/barghchigroup'],
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+982135000020 ',
        contactType: 'customer service',
        areaServed: 'IR',
        availableLanguage: 'Persian',
      },
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'PC68+WQQ District 6, Tehran, Tehran Province',
        addressLocality: 'Tehran, Iran',
        postalCode: '',
        areaServed: {
          '@context': 'https://schema.org',
          '@type': 'Place',
          geo: {
            '@type': 'GeoCoordinates',
            latitude: '35.712318',
            longitude: '51.416962',
          },
          hasMap:
            "https://www.google.com/maps/place/35%C2%B042'44.3%22N+51%C2%B025'01.1%22E/@35.7123827,51.4162448,18.42z/data=!4m5!3m4!4b1!8m2!3d35.712318!4d51.416962?hl=en-IR&entry=ttu",
        },
        addressCountry: {
          '@type': 'Country',
          name: 'Iran',
        },
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      id: 'https://www.barghchi.com/#webSite',
      name: 'برقچی',
      url: 'https://www.barghchi.com',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.barghchi.com/search/?q={search_term_string}',
        'query-input': {
          '@type': 'PropertyValueSpecification',
          valueRequired: 'http://schema.org/True',
          valueName: 'search_term_string',
        },
      },
      copyrightHolder: {
        '@type': 'Corporation',
        id: 'https://www.barghchi.com/#corporation',
        name: 'برقچی',
      },
      creator: {
        '@type': 'Corporation',
        id: 'https://www.barghchi.com/#corporation',
        name: 'برقچی',
      },
    },
  ];

  return indexSchema;
};
